import { detectContentFormat } from '../../utils/contentUtils.js';

export function resolveEditorInputFormat(content, explicitFormat) {
  if (explicitFormat && explicitFormat !== 'auto') {
    return explicitFormat;
  }

  return detectContentFormat(content);
}
